
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire34b5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire34b5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6mvtm", function(module, exports) {
$parcel$export(module.exports, "RELAY_API_CONTENTFUL", function () { return $e62c9da570d0cc47$export$7b31a9938ec3ba75; });
const $e62c9da570d0cc47$export$7b31a9938ec3ba75 = "contentful";

});

parcelRegister("3t7DW", function(module, exports) {
$parcel$export(module.exports, "init", function () { return $be9c067c7be4fda0$export$2cd8252107eb640b; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $yhhhl = parcelRequire("yhhhl");

var $konOj = parcelRequire("konOj");

var $f3gS9 = parcelRequire("f3gS9");

var $fuLgT = parcelRequire("fuLgT");

var $eQyIx = parcelRequire("eQyIx");

var $g0QpW = parcelRequire("g0QpW");

var $6mvtm = parcelRequire("6mvtm");

var $eRzlV = parcelRequire("eRzlV");

var $6r14Z = parcelRequire("6r14Z");

var $hgaI1 = parcelRequire("hgaI1");

var $7mHQv = parcelRequire("7mHQv");

var $i2Oi2 = parcelRequire("i2Oi2");

var $2h4sD = parcelRequire("2h4sD");

var $hp3ar = parcelRequire("hp3ar");

var $gLm0b = parcelRequire("gLm0b");

var $6gQvZ = parcelRequire("6gQvZ");

var $idVA4 = parcelRequire("idVA4");

var $hu7gH = parcelRequire("hu7gH");
window.BUILD_KEY = "p-be3959a8f6";
window.featureGateBootstrapValues = window.featureGateBootstrapValues || {
    identifiers: {
        analyticsAnonymousId: (0, $fuLgT.default)()
    }
};
const $be9c067c7be4fda0$var$SUPPORTED_LOCALES = [
    {
        hrefLang: "ja",
        langRoute: "ja"
    },
    {
        hrefLang: "fr",
        langRoute: "fr"
    },
    {
        hrefLang: "de",
        langRoute: "de"
    },
    {
        hrefLang: "es",
        langRoute: "es"
    },
    {
        hrefLang: "pt-BR",
        langRoute: "br"
    },
    {
        hrefLang: "zh-Hans",
        langRoute: "zh"
    },
    {
        hrefLang: "ko",
        langRoute: "ko"
    },
    {
        hrefLang: "ru",
        langRoute: "ru"
    },
    {
        hrefLang: "pl",
        langRoute: "pl"
    },
    {
        hrefLang: "it",
        langRoute: "it"
    },
    {
        hrefLang: "nl",
        langRoute: "nl"
    }
];
const $be9c067c7be4fda0$export$2cd8252107eb640b = (Component, query, queryVars, relayApi)=>{
    const analyticsWebClient = (0, $g0QpW.getAnalyticsWebClient)();
    const { locale: locale, path: path } = (0, $hu7gH.parseRoute)(window.location);
    // Get location data for experiments and feature gates from server-provided data
    let locationData;
    // Use server-provided data (no client-side API calls)
    if (typeof window !== "undefined") locationData = {
        countryIsoCode: window.countryCode || "",
        regionIsoCode: window.regionIsoCode || ""
    };
    const isPerfOnetrustEnabled = (0, $gLm0b.isPerformanceOnetrustEnabled)(typeof window !== "undefined" ? window.optanonConsentCookie : (0, $gLm0b.extractOptanonConsentCookie)(document.cookie), locationData);
    isPerfOnetrustEnabled && (0, $eQyIx.initUFO)(analyticsWebClient, path);
    const parsedClientCookies = document.cookie ? (0, $yhhhl.parse)(document.cookie) : {};
    const userAgent = typeof window !== "undefined" ? window.navigator.userAgent : "";
    const { finalExperimentOverrides: finalExperimentOverrides, finalFeatureGateOverrides: finalFeatureGateOverrides } = (0, $idVA4.processExperimentAndFeatureGateOverrides)(parsedClientCookies, userAgent, isPerfOnetrustEnabled);
    if ((0, $hp3ar.isEdgeCachingPath)(window.location)) {
        // Override for Edge Caching
        (0, $hp3ar.overrideAjsAnonIdFromCookie)();
        (0, $hp3ar.overrideCustomAttributes)();
    }
    (0, $hgaI1.initializeFeatureGatesClient)(window.featureGateBootstrapValues, {
        overrideValues: {
            experimentOverrides: finalExperimentOverrides,
            featureGateOverrides: finalFeatureGateOverrides
        },
        // if performance cookies are disabled, we will skip exposures
        localMode: !isPerfOnetrustEnabled
    }).then(async ()=>{
        try {
            await (0, $2h4sD.DynamicConfigClient).getInstance().initialize({
                bootstrapValues: window.featureGateBootstrapValues
            });
        } catch (error) {
            console.error("Failed to initialize DynamicConfigClient", error);
        }
        const isStatic = typeof window !== "undefined" && window.IS_STATIC;
        const snapshot = window.relayStoreSnapshot;
        let relayBaseUrl = undefined;
        let relayAuthKey = undefined;
        if (relayApi === (0, $6mvtm.RELAY_API_CONTENTFUL)) {
            relayBaseUrl = (0, $eRzlV.CONTENTFUL_GRAPHQL_API_URL);
            relayAuthKey = window.CONTENTFUL_DELIVERY_KEY_PRODUCT_TEMPLATES;
        }
        const relayEnvironment = (0, $i2Oi2.initRelayEnvironment)(snapshot, relayBaseUrl, relayAuthKey);
        const queryRef = (0, $f3gS9.loadQuery)(relayEnvironment, query, queryVars);
        const canonicalBaseUrl = (0, $6r14Z.getCanonicalBaseUrl)(window.location.hostname, path);
        const pathForCanonical = path ? (0, $6r14Z.canonicalPathForHref)(canonicalBaseUrl, path) : undefined;
        const route = pathForCanonical === undefined ? "" : pathForCanonical === "" ? "" : `/${pathForCanonical}`;
        const page = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6gQvZ.SentryIntlProvider), {
            locale: locale,
            messages: window.SSR_languagePack,
            cookies: document.cookie,
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $f3gS9.RelayEnvironmentProvider), {
                environment: relayEnvironment,
                children: [
                    isStatic && /*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                        rel: "canonical",
                        href: `${canonicalBaseUrl}${route}`
                    }),
                    isStatic && /*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                        rel: "alternate",
                        href: `${canonicalBaseUrl}${route}`,
                        hrefLang: "x-default"
                    }),
                    isStatic && $be9c067c7be4fda0$var$SUPPORTED_LOCALES.map(({ hrefLang: hrefLang, langRoute: langRoute })=>/*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                            rel: "alternate",
                            href: `${canonicalBaseUrl}/${langRoute}${route}`,
                            hrefLang: hrefLang
                        }, hrefLang)),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7mHQv.PageWrapper), {
                        analyticsWebClient: analyticsWebClient,
                        location: window.location,
                        pricing: window.prices,
                        availableProducts: window.availableProducts,
                        userProfile: window.userProfile,
                        userProfileStatus: window.userProfileStatus,
                        userContext: window.userContext,
                        userContextStatus: window.userContextStatus,
                        loggedOutContext: window.loggedOutContext,
                        loggedOutContextStatus: window.loggedOutContextStatus,
                        loggedInContext: window.loggedInContext,
                        loggedInContextStatus: window.loggedInContextStatus,
                        countryCode: window.countryCode,
                        mlTemplateIds: window.mlTemplateIds,
                        keyword: window.keyword,
                        anchor: window.anchor,
                        subAnchor: window.subAnchor,
                        queryRef: queryRef,
                        PageComponent: Component,
                        transactionAccounts: window.transactionAccounts,
                        userAgent: userAgent
                    })
                ]
            })
        });
        if (isStatic) {
            // @ts-ignore
            const root = (0, $konOj.createRoot)(document.getElementById("wac"));
            root.render(page);
        } else (0, $konOj.hydrateRoot)(// @ts-ignore
        document.getElementById("wac-root"), page, {
            onRecoverableError: (error, errorInfo)=>{
                document.getElementById("wac-root")?.setAttribute("hydration-error", "true");
            }
        });
    });
};

});
parcelRegister("i2Oi2", function(module, exports) {
$parcel$export(module.exports, "initRelayEnvironment", function () { return $36b5b9e576032b2f$export$1456be3de97c862f; });

var $gRpMo = parcelRequire("gRpMo");
(0, $gRpMo.RelayFeatureFlags).ENABLE_LOAD_QUERY_REQUEST_DEDUPING = true;
// TODO: Lift this into environment
const $36b5b9e576032b2f$var$GATEWAY_URL = "https://www.atlassian.com/gateway/api/graphql";
function $36b5b9e576032b2f$var$createRelayEnvironment(initialRecords, baseUrlOverride, authToken) {
    const baseUrl = baseUrlOverride ?? $36b5b9e576032b2f$var$GATEWAY_URL;
    let headers = {
        "Content-Type": "application/json"
    };
    if (authToken) headers = Object.assign({}, headers, {
        Authorization: `Bearer ${authToken}`
    });
    const fetchResponse = (params, variables)=>{
        const startTime = Date.now();
        const response = fetch(baseUrl, {
            method: "POST",
            headers: headers,
            // Contentful uses an authToken, and Access-Control-Allow-Origin = "*",
            // therefore we cannot include credentials for Contentful queries
            credentials: authToken ? "same-origin" : "include",
            body: JSON.stringify({
                query: params.text,
                variables: variables
            })
        });
        return (0, $gRpMo.Observable).from(response.then(async (res)=>{
            const duration = Date.now() - startTime;
            // @ts-ignore
            if (!globalThis.IS_STATIC) try {
                // @ts-ignore
                globalThis.metrics.histogram(`contentful.duration`, "10_100_500_1000_2000_3000_5000_10000_30000", duration, {
                    gqlOperationName: params.name,
                    cacheStatus: res.headers.get("x-cache"),
                    status: res.status
                });
            } catch (e) {
                console.error(`Failed to track ${params.name} call`, e);
            }
            return res.json();
        }));
    };
    const network = (0, $gRpMo.Network).create(fetchResponse);
    const store = new (0, $gRpMo.Store)(new (0, $gRpMo.RecordSource)(initialRecords));
    return new (0, $gRpMo.Environment)({
        network: network,
        store: store
    });
}
let $36b5b9e576032b2f$var$clientSideRelayEnvironment;
function $36b5b9e576032b2f$export$1456be3de97c862f(initialRecords, baseUrlOverride, authToken) {
    const environment = $36b5b9e576032b2f$var$clientSideRelayEnvironment ?? $36b5b9e576032b2f$var$createRelayEnvironment(initialRecords, baseUrlOverride, authToken);
    if (typeof window === "undefined") return environment;
    if (!$36b5b9e576032b2f$var$clientSideRelayEnvironment) $36b5b9e576032b2f$var$clientSideRelayEnvironment = environment;
    else if (initialRecords) environment.getStore().publish(new (0, $gRpMo.RecordSource)(initialRecords));
    return $36b5b9e576032b2f$var$clientSideRelayEnvironment;
}

});


parcelRegister("kPZ6t", function(module, exports) {
$parcel$export(module.exports, "ConfluenceTemplateCategoryRelayPage", function () { return $7acae86b58c469af$export$edf498f6a1736180; });

var $7VQPk = parcelRequire("7VQPk");

var $1YXN8 = parcelRequire("1YXN8");
const $7acae86b58c469af$export$edf498f6a1736180 = ({ queryRef: queryRef })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1YXN8.ConfluenceTemplatesUnifiedRelayPageTemplate), {
        queryRef: queryRef
    });
};

});


var $6mvtm = parcelRequire("6mvtm");

var $3t7DW = parcelRequire("3t7DW");

var $kPZ6t = parcelRequire("kPZ6t");

var $1YXN8 = parcelRequire("1YXN8");
(0, $3t7DW.init)((0, $kPZ6t.ConfluenceTemplateCategoryRelayPage), (0, $1YXN8.ConfluenceTemplatesUnifiedRelayPageQuery), (0, $1YXN8.getConfluenceTemplatesUnifiedRelayPageQueryVars)(window.location), (0, $6mvtm.RELAY_API_CONTENTFUL));


//# sourceMappingURL=confluence-template-category-contentful-relay-page.4284ac79.js.map
